import { set } from 'quartz/globalState/api';
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import BasicI18nSetup from 'I18n/init/setup/BasicI18nSetup';
import BasicPublicI18nSetup from 'I18n/init/setup/BasicPublicI18nSetup';
import { I18N_PROVIDER } from './globalState';
export async function initializeI18n({
  langs,
  localeInfo,
  createPublicProvider,
  registerFn,
  trackSetLocale
}) {
  const i18nProvider = createPublicProvider ? createPublicI18nProvider({
    manuallySetLocale: !!localeInfo
  }) : createStandardI18nProvider();
  const langAvailable = initAppTranslations([...langs.map(lang => i18nProvider.register(lang)), registerFn(i18nProvider)]);
  if (localeInfo) {
    i18nProvider.setLocale(localeInfo);
  } else if (!createPublicProvider) {
    // The public provider calculates locale internally if not overridden
    i18nProvider.setLocale({
      langEnabled: false
    });
  }

  // For back-compat with BasicI18nSetup
  BasicI18nSetup.provider = i18nProvider;
  BasicPublicI18nSetup.provider = i18nProvider;
  set(I18N_PROVIDER, {
    register: i18nProvider.register,
    setLocale: () => {
      trackSetLocale();
    }
  });
  await langAvailable;
}